const CSV_HEADERS = [
  'Project',
  'Project status',
  'Project launch date',
  'First email date',
  'Linked job',
  'Company',
  'Link status',
  'Link source',
  'Candidates contacted',
  'Any-link clickers',
  'Any-link CTR (%)',
  'Talent Community link clickers',
  'Job page views',
  'Unique job visitors',
  'Apply button clicks',
];

const FORMULA_PREFIX = /^[\t\r\n ]*[=+\-@]/;
const LINK_SOURCE_LABELS = { exact: 'Automatic', auto: 'Outreach email' };

export const displayProjectName = (name = '') => String(name).replace(/^\d+_SO_/i, '');

const isoDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const sourceDate = typeof value === 'string' && value.match(/^(\d{4}-\d{2}-\d{2})(?:T|$)/);
  if (sourceDate) return sourceDate[1];

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const numberValue = (value, available) => {
  if (!available || value === null || value === undefined) return '';
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : '';
};

const percentValue = (value, available) => {
  const numericValue = numberValue(value, available);
  return numericValue === '' ? '' : Number((numericValue * 100).toFixed(2));
};

const linkSourceLabel = (project) => {
  if (!project.job) return '';
  return LINK_SOURCE_LABELS[project.mappingSource] || 'Manual';
};

const escapeCsvCell = (value) => {
  let serialized = value === null || value === undefined ? '' : String(value);
  if (typeof value === 'string' && FORMULA_PREFIX.test(serialized)) serialized = `'${serialized}`;
  return /[",\r\n]/.test(serialized) ? `"${serialized.replace(/"/g, '""')}"` : serialized;
};

export const buildProjectAnalyticsCsv = ({
  projects = [],
  linkedJobs = [],
  hasOutreachData = true,
  hasJobData = true,
}) => {
  const metricsByJobId = new Map(linkedJobs.map((job) => [String(job.id), job]));
  const rows = projects.map((project) => {
    const jobMetric = project.job ? metricsByJobId.get(String(project.job.id)) : null;
    const jobMetricsAvailable = hasJobData && Boolean(jobMetric);

    return [
      displayProjectName(project.name),
      project.status || '',
      isoDate(project.createdAt),
      isoDate(project.firstSentAt),
      project.job?.title || '',
      project.job?.company?.name || '',
      project.job ? 'Linked' : 'Not linked',
      linkSourceLabel(project),
      numberValue(project.contacts, hasOutreachData),
      numberValue(project.anyLinkClickers, hasOutreachData),
      percentValue(project.anyLinkCtr, hasOutreachData),
      numberValue(project.talentCommunityLinkClickers, hasOutreachData),
      numberValue(jobMetric?.pageViews, jobMetricsAvailable),
      numberValue(jobMetric?.uniqueViewers, jobMetricsAvailable),
      numberValue(jobMetric?.applyClicks, jobMetricsAvailable),
    ];
  });
  const csvRows = [CSV_HEADERS, ...rows].map((row) => row.map(escapeCsvCell).join(','));

  return `\uFEFF${csvRows.join('\r\n')}\r\n`;
};

const filenamePart = (value, fallback) => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return normalized || fallback;
};

export const buildProjectAnalyticsFilename = ({ networkSlug, dateFrom, dateTo, downloadedAt = new Date() }) => {
  const network = filenamePart(networkSlug, 'network');
  const range = dateFrom && dateTo ? `launched-${dateFrom}-to-${dateTo}` : 'all-launch-dates';
  const downloadDate = isoDate(downloadedAt);

  return `outreach-performance-${network}-${range}-${downloadDate}.csv`;
};
